'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'triangle-exclamation';
var width = 576;
var height = 512;
var aliases = [9888,"exclamation-triangle","warning"];
var unicode = 'f071';
var svgPathData = 'M306.2 17.3L542.4 448 560 480 16 480 33.6 448 269.8 17.3 288-16 306.2 17.3zM70 448L506 448 288 50.6 70 448zm238-52l-40 0 0-40 40 0 0 40zm-8.8-76l-22.4 0-12.8-144 48 0-12.8 144z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTriangleExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;